/**
 * @fileoverview Root page route configuration
 * Redirects users to login or dashboard based on authentication status
 */

// Library imports
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/providers/auth.provider";
import { AuthState } from "@/types/auth.types";
import { LoadingOverlay } from "@/components/shared/loading-overlay";

/**
 * Root component that handles redirection based on auth state
 */
function RootPage() {
  const { authState } = useAuth();

  // Show loading while checking authentication
  if (authState === AuthState.AUTHENTICATING || authState === AuthState.IDLE) {
    return <LoadingOverlay isLoading={true} />;
  }

  // Redirect to dashboard if authenticated, otherwise to login
  return (
    <Navigate
      to={authState === AuthState.AUTHENTICATED ? "/dashboard" : "/login"}
      replace
    />
  );
}

/**
 * Route configuration for the root page
 * Automatically redirects users based on their authentication status
 */
export const Route = createFileRoute("/(public)/_public/")({
  component: RootPage,
});
